var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourierActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FDE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H24.3373C24.5818 15 24.7041 15 24.8192 15.0276C24.9213 15.0521 25.0188 15.0925 25.1083 15.1474C25.2092 15.2092 25.2957 15.2957 25.4686 15.4686L29.5314 19.5314C29.7043 19.7043 29.7908 19.7908 29.8526 19.8917C29.9075 19.9812 29.9479 20.0787 29.9724 20.1808C30 20.2959 30 20.4182 30 20.6627V23.5C30 23.9659 30 24.1989 29.9239 24.3827C29.8224 24.6277 29.6277 24.8224 29.3827 24.9239C29.1989 25 28.9659 25 28.5 25M23.5 25H22M22 25V15.2C22 14.0799 22 13.5198 21.782 13.092C21.5903 12.7157 21.2843 12.4097 20.908 12.218C20.4802 12 19.9201 12 18.8 12H13.2C12.0799 12 11.5198 12 11.092 12.218C10.7157 12.4097 10.4097 12.7157 10.218 13.092C10 13.5198 10 14.0799 10 15.2V23C10 24.1046 10.8954 25 12 25M22 25H18M18 25C18 26.6569 16.6569 28 15 28C13.3431 28 12 26.6569 12 25M18 25C18 23.3431 16.6569 22 15 22C13.3431 22 12 23.3431 12 25M28.5 25.5C28.5 26.8807 27.3807 28 26 28C24.6193 28 23.5 26.8807 23.5 25.5C23.5 24.1193 24.6193 23 26 23C27.3807 23 28.5 24.1193 28.5 25.5Z",
    stroke: "url(#paint0_linear_496_252335)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_496_252335",
    x1: 10,
    y1: 12,
    x2: 30.3381,
    y2: 12.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourierActive);
export default __webpack_public_path__ + "static/media/CourierActive.e8f716dd30d4c0e573ec6fad437c2dee.svg";
export { ForwardRef as ReactComponent };